import {
	atom,
} from 'recoil';
import { recoilPersist } from 'recoil-persist';
import { Address } from 'src/base/types';

const { persistAtom } = recoilPersist();

const addressAtom = atom<Address>({
	key: 'address', // unique ID (with respect to other atoms/selectors)
	default: null, // default value (aka initial value)
	effects_UNSTABLE: [persistAtom],
});

export default addressAtom;
